/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Filter_AllInputs */

const vi_print_admin_filter_all = /** @type {(inputs: Print_Admin_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả trạng thái`)
};

/**

* @param {Print_Admin_Filter_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_filter_all = /** @type {((inputs?: Print_Admin_Filter_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Filter_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_filter_all(inputs)
});